<script>
// 仅保留核心必需的OL模块导入（全局仅导入一次Draw）
import 'ol/ol.css';
import { Style, Stroke, Fill, Icon } from 'ol/style';
import { Vector as VectorSource } from 'ol/source';
import { Draw } from 'ol/interaction';
import { Point } from 'ol/geom';
import { OMapMixin } from '@OpenLayersCommon';
import { createBox } from 'ol/interaction/Draw.js';
import getDrawParams from './getDrawParams.js';
import api from '../../api';

export default {
    props: {
        selectLDrawType: String,
        drawInfoList: Array,
    },
    mixins: [OMapMixin],
    data() {
        return {
            map: null,
            draw: null,
            VectorSource: null,
            geometryFunction: null,
        };
    },
    computed: {
        // 计算当前绘制类型对应的几何类型
        geometryType() {
            switch (this.selectLDrawType) {
                case 'warningLine-1':
                case 'warningLine-2':
                case 'warningLine-3':
                case 'intercept':
                case 'Traffic-polygon':
                case 'Traffic-square':
                case 'suspicion-square':
                case 'suspicion-polygon':
                    return 'Polygon';
                case 'dangerPoint':
                case 'firePoint':
                case 'Traffic-start':
                case 'Traffic-end':
                case 'Traffic-kakou':
                case 'suspicion-user':
                    return 'Point';
                case 'wind':
                case 'Traffic-road':
                    return 'LineString';
                case 'Traffic-circle':
                case 'suspicion-circle':
                    return 'Circle';
                default:
                    return null;
            }
        },
        // 警戒线样式（Polygon专用）
        warningLineStyle() {
            let width = null;
            let color = null;
            switch (this.selectLDrawType) {
                case 'warningLine-1':
                    width = 2;
                    color = '#d6550d';
                    break;
                case 'warningLine-2':
                    width = 3;
                    color = '#d3ad28';
                    break;
                case 'warningLine-3':
                    width = 4;
                    color = '#78cb0e';
                    break;
                default:
                    break;
            }
            return { width, color };
        },
    },
    methods: {
        // 封装OL样式创建方法（子组件调用）
        createOLStyle(options) {
            return new Style(options);
        },
        createOLStroke(options) {
            return new Stroke(options);
        },
        createOLFill(options) {
            return new Fill(options);
        },
        createOLIcon(options) {
            return new Icon(options);
        },
        createOLVectorSource(options) {
            return new VectorSource(options);
        },
        createOLPoint(coords) {
            return new Point(coords);
        },

        // 核心封装：创建Draw交互（子组件无需再导入Draw）
        createOLDraw(options) {
            const defaultOptions = {
                source: this.VectorSource,
                wrapX: false,
                geometryFunction: this.geometryFunction,
            };
            const drawOptions = { ...defaultOptions, ...options };
            return new Draw(drawOptions);
        },

        // 初始化地图和数据源
        async initMap() {
            this.map = await this.getMap();
            this.VectorSource = this.createOLVectorSource({ wrapX: false });
            // 设置矩形绘制的几何函数
            if (this.selectLDrawType === 'Traffic-square' || this.selectLDrawType === 'suspicion-square') {
                this.geometryFunction = createBox();
            } else {
                this.geometryFunction = null;
            }
        },

        // 删除绘制交互
        removeDraw() {
            this.draw && this.map.removeInteraction(this.draw);
            this.draw = null;
        },

        // 图标过滤函数（Point专用）
        srcFilterFn(type) {
            let obj;
            switch (type) {
                case 'dangerPoint':
                    obj = {
                        src: require('../images/icon-danger.png'),
                        offset: [-15, 10],
                        size: [100, 100],
                    };
                    break;
                case 'firePoint':
                    obj = {
                        src: require('../images/icon-fire.png'),
                    };
                    break;
                case 'Traffic-start':
                    obj = {
                        src: require('../images/icon-start.png'),
                        anchor: [0.5, 0.9],
                    };
                    break;
                case 'Traffic-end':
                    obj = {
                        src: require('../images/icon-end.png'),
                        anchor: [0.5, 0.9],
                    };
                    break;
                case 'Traffic-kakou':
                    obj = {
                        src: require('../images/icon-kakou.png'),
                        anchor: [0.5, 0.9],
                    };
                    break;
                case 'suspicion-user':
                    obj = {
                        src: require('../images/icon_suspicion-user.png'),
                        anchor: [0.5, 0.9],
                    };
                    break;
                default:
                    break;
            }
            return obj;
        },

        // 通用的保存绘制信息方法
        // async saveDrawInfo(params) {
        //     const tempObj = getDrawParams(params);
        //     console.log('tempObj', tempObj);
        //     await api.saveDrawInfo(tempObj).run();
        // },

        // 触发父组件事件
        emitParentEvents() {
            this.$emit('getDrawInfoListInToday');
            this.$emit('handleMeasureTypeChange', null);
        },
    },
};
</script>
